import React from "react";

/* ══════════════════════════════════════════════════════════════
   GRANTHA LOGO — AI-Powered Engineering Data & Document Management
   Spec: user-provided grantha master SVG kit + updates (Apr 21, 2026):
     - Wordmark "grantha" with italic orange accent "n"
     - Devanagari  below
     - Tagline "AI POWERED ENGINEERING DATA & DOCUMENT MANAGEMENT"
   Concept: 3 isometric stacked document layers + orange AI-spark star.
   Theme-aware via CSS variables.
   ══════════════════════════════════════════════════════════════ */

/* Standalone icon mark — scales from 16px to 256px. */
export function GranthaIcon({ size = 64, className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      aria-hidden="true"
      className={`gr-mark ${className}`}
    >
      <g transform="translate(8, 10)">
        <path d="M0 38 L24 28 L48 36 L24 46 Z" className="gr-layer-bottom" />
        <path d="M0 26 L24 16 L48 24 L24 34 Z" fill="#1E4E8C" opacity="0.9" />
        <path d="M0 14 L24 4 L48 12 L24 22 Z" fill="#2E70AD" />
        <g transform="translate(41, 0)">
          <path d="M0 -7 L1.8 -1.8 L7 0 L1.8 1.8 L0 7 L-1.8 1.8 L-7 0 L-1.8 -1.8 Z" fill="#F26B1F" />
        </g>
      </g>
    </svg>
  );
}

/* Full logo — icon + wordmark (with orange italic "n") + Devanagari + tagline.
   Used in PlatformGrantha hero.
*/
export default function GranthaLogo({ height = 120, className = "" }) {
  const viewW = 620;
  const viewH = 168;
  const w = Math.round(viewW * height / viewH);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${viewW} ${viewH}`}
      width={w}
      height={height}
      role="img"
      aria-label="Docuweave — AI-Powered Engineering Data & Document Management"
      className={`gr-logo-full ${className}`}
    >
      {/* ICON: 3 isometric stacked layers */}
      <g transform="translate(30, 14)">
        <path d="M0 48 L30 36 L60 44 L30 56 Z" className="gr-layer-bottom" />
        <path d="M0 34 L30 22 L60 30 L30 42 Z" fill="#1E4E8C" opacity="0.9" />
        <path d="M0 20 L30 8 L60 16 L30 28 Z" fill="#2E70AD" />
        <g transform="translate(52, 4)">
          <path d="M0 -8 L2 -2 L8 0 L2 2 L0 8 L-2 2 L-8 0 L-2 -2 Z" fill="#F26B1F" />
        </g>
      </g>

      {/* WORDMARK: "Docu" + italic orange "w" + "eave" — family style (italic Playfair Display) */}
      <text
        x="118"
        y="84"
        fontFamily="'Playfair Display', Georgia, serif"
        fontSize="82"
        fontWeight="400"
        fontStyle="italic"
        letterSpacing="-0.02em"
      >
        <tspan className="gr-wordmark-text">Docu</tspan>
        <tspan fill="#F26B1F" fontStyle="italic" fontWeight="400">w</tspan>
        <tspan className="gr-wordmark-text">eave</tspan>
      </text>
    </svg>
  );
}
